











import { Vue, Component, Watch } from 'vue-property-decorator';
import { MessageType } from '@/config/enum';
import messageModule from '@/store/modules/common/message.module';

@Component({
  name: 'v-message'
})
export default class VMessage extends Vue {
  public currentTimeout = -1;
  get type(): MessageType | null {
    return messageModule.type;
  }

  get message(): string | null {
    return messageModule.message;
  }

  get alertClass(): string | null {
    return 'alert-' + this.type;
  }

  async close() {
    await messageModule.setMessage(null);
  }

  @Watch('message', { immediate: true, deep: false })
  public changeMessage() {
    if (this.message != null && this.currentTimeout < 0) {
      this.currentTimeout = setTimeout(() => {
        messageModule.setMessage(null);
        this.currentTimeout = -1;
      }, 3000);
    }
  }
}
